export { default as AddedToCart } from "./AddedToCart";
